import React from "react";
import { Link } from "react-router-dom";
import "../Portfolio.css";

const LoteriaPrivacyPolicy = () => {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <Link to="/privacy" className="privacy-back-link">
          &larr; Back to Privacy Policies
        </Link>
        <h1 className="privacy-title">
          La Loteria - Mexican Bingo App
          <span className="privacy-title-dot">.</span>
        </h1>
        <p className="privacy-intro">
          La Loteria - Mexican Bingo ("the App") is developed by Bryan Arambula.
          This Privacy Policy explains how the App handles your information.
        </p>
        <p className="privacy-intro">
          La Loteria does not collect, store, or share any personal data. Your
          privacy is fully protected.
        </p>

        <h2 className="privacy-section-title">Information We Collect</h2>
        <p className="privacy-text">
          The App does not collect any personal information. Specifically:
        </p>
        <ul className="privacy-list">
          <li>No personal data is collected (name, email, phone number, etc.)</li>
          <li>No usage data or analytics are gathered</li>
          <li>No location data is accessed</li>
          <li>No cookies or tracking technologies are used</li>
          <li>No account creation is required</li>
        </ul>

        <h2 className="privacy-section-title">How the App Works</h2>
        <p className="privacy-text">
          La Loteria operates entirely on your device. All game functionality —
          including card shuffling, card calling, voice announcements, speed
          settings, and card history — is processed locally. The App does not
          require an internet connection to function.
        </p>

        <h2 className="privacy-section-title">Third-Party Services</h2>
        <p className="privacy-text">
          The App does not integrate with any third-party services, advertising
          networks, or analytics platforms. No data is shared with any third
          parties.
        </p>

        <h2 className="privacy-section-title">Children's Privacy</h2>
        <p className="privacy-text">
          La Loteria is a family-friendly game suitable for all ages. Since the
          App does not collect any personal information from anyone, it is
          compliant with the Children's Online Privacy Protection Act (COPPA) and
          similar regulations worldwide.
        </p>

        <h2 className="privacy-section-title">Data Storage</h2>
        <p className="privacy-text">
          The App stores your game preferences (such as language selection and
          speed settings) locally on your device only. This data never leaves
          your device and can be removed by deleting the App.
        </p>

        <h2 className="privacy-section-title">Changes to This Policy</h2>
        <p className="privacy-text">
          We may update this Privacy Policy from time to time. Any changes will
          be reflected on this page with an updated revision date. Continued use
          of the App after any changes constitutes acceptance of the updated
          policy.
        </p>

        <h2 className="privacy-section-title">Contact Us</h2>
        <p className="privacy-text">
          If you have any questions about this Privacy Policy or the App, please
          contact me at:
        </p>
        <div className="privacy-contact-info">
          <p>
            <strong>Bryan Arambula</strong>
          </p>
          <p>Software Developer</p>
          <p>
            Email:{" "}
            <a href="mailto:bryan@bryandevelops.com" className="privacy-email-link">
              bryan@bryandevelops.com
            </a>
          </p>
          <p>
            Website:{" "}
            <a
              href="https://bryanarambula.com"
              target="_blank"
              rel="noopener noreferrer"
              className="privacy-email-link"
            >
              bryanarambula.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoteriaPrivacyPolicy;
